import { Component, Input, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

@Component({
    selector: 'app-filter-category-modal',
    templateUrl: './filter-category-modal.component.html',
    styleUrls: ['./filter-category-modal.component.scss'],
    standalone: true,
    imports: [CommonModule, FormsModule, IonicModule],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class FilterCategoryModalComponent {
    @Input() list: any[] = [];
    @Input() title = '';

    searchQuery = '';

    constructor(private modalCtrl: ModalController) {}

    trackByIndex = (index: number): number => index;

    get filteredList(): any[] {
        const q = (this.searchQuery || '').trim().toLowerCase();
        if (!q) return this.list || [];
        return (this.list || []).filter(
            (it) =>
                (it?.value ?? '').toLowerCase().includes(q) ||
                (it?.display ?? '').toLowerCase().includes(q)
        );
    }

    toggle(item: any): void {
        if (item) item.checked = !item.checked;
    }

    apply(): void {
        const listToReturn = (this.list || []).map((el: any) => ({ ...el }));
        this.modalCtrl.dismiss({ list: listToReturn });
    }

    close(): void {
        this.modalCtrl.dismiss();
    }
}
